module.exports = __webpack_public_path__ + "static/media/desc_Banner_Data_API_GATEWAY-06-06.f88bcab5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banners/courses/APIGATEWAY/desc_Banner_Data_API_GATEWAY-06-06.png
// module id = 280
// module chunks = 0